<mat-card class="betriebskontakt-card">
    <mat-card-header>
        <div class="mat-card-header-text" style="margin-left: 0px; margin-right: 0px"></div>
        <div class="card-header-content">
            <!-- Links: Betriebsname -->
            <div class="card-title-section">
                <div class="title-row">
                    <mat-card-title>{{ vvvo.bezeichnung }}</mat-card-title>
                </div>
                <mat-card-subtitle *ngIf="vvvo.zusatz" class="zusatz-subtitle">{{ vvvo.zusatz }}</mat-card-subtitle>
            </div>

            <!-- Rechts: Button -->
            <div class="card-actions" *ngIf="!hideActions">
                <button mat-icon-button [matMenuTriggerFor]="vvvoMenu" class="menu-button">
                    <mat-icon>more_vert</mat-icon>
                </button>
            </div>
        </div>
    </mat-card-header>

    <!-- Visueller Trenner zwischen Header und Body -->
    <div class="card-divider"></div>

    <mat-card-content>
        <div class="kontakt-info">
            <div class="info-row" *ngIf="vvvo.vvvo">
                <mat-icon>business</mat-icon>
                <span>VVVO: {{ vvvo.vvvo }}</span>
            </div>
            <div class="info-row" *ngIf="vvvo.betriebsart">
                <mat-icon>category</mat-icon>
                <span>{{ vvvo.betriebsart }}</span>
            </div>
            <div class="info-row" *ngIf="getVollAdresse(vvvo)">
                <mat-icon>location_on</mat-icon>
                <span>{{ getVollAdresse(vvvo) }}</span>
            </div>
            <div class="info-row" *ngIf="vvvo.email">
                <mat-icon>email</mat-icon>
                <a href="mailto:{{ vvvo.email }}" class="contact-link" (click)="onSendMail()">
                    {{ vvvo.email }}
                </a>
            </div>
            <div class="info-row" *ngIf="getLieferadresse(vvvo)">
                <mat-icon>local_shipping</mat-icon>
                <span>Lieferung: {{ getLieferadresse(vvvo) }}</span>
            </div>
        </div>
    </mat-card-content>

    <!-- Menü für Aktionen (ohne Trigger unschädlich; Trigger wird bei hideActions ausgeblendet) -->
    <mat-menu #vvvoMenu>
        <button mat-menu-item (click)="onBearbeiten()">
            <mat-icon>edit</mat-icon>
            <span>Bearbeiten</span>
        </button>
        <button mat-menu-item (click)="onEntfernen()" style="color: #f44336">
            <mat-icon>delete</mat-icon>
            <span>Betrieb entfernen</span>
        </button>
        <button mat-menu-item *kienePermission="[9999]" (click)="onFreigabePraxis()">
            <mat-icon>local_hospital</mat-icon>
            <span>Tierarztpraxis Freigabe erteilen</span>
        </button>
    </mat-menu>
</mat-card>
